import { BaseLayout } from "src/layout";
import { useEffect } from "react";
import { useRouter } from "next/router";

export default function Overview() {
  const router = useRouter();

  useEffect(() => {
    const localStorageItem = localStorage.getItem('dts-should-redirect');

    if (localStorageItem) router.push('/dashboard')
    else router.replace('/auth/login')
  }, [router]);

  return <></>;
}

Overview.getLayout = function getLayout(page) {
  return <BaseLayout>{page}</BaseLayout>;
};
